module.exports = __webpack_public_path__ + "static/media/CD__0000_0001.fcc388ba.png";